import i18n from 'i18n/config';

export function getActivitySensorTypeLabel(t = i18n.t.bind(i18n), serialNumber) {
  if (!serialNumber) return '';
  const isTransmitter = serialNumber.split('-')[0] === 'TX';
  return t(
    isTransmitter
      ? 'activity.activityFormat.sensorTypes.transmitter'
      : 'activity.activityFormat.sensorTypes.mote',
    { defaultValue: isTransmitter ? 'transmitter' : 'mote' }
  );
}

export function getMoteUnreachableTitleText(t, activity) {
  return t('activity.activityFormat.titles.moteUnreachableTitle', {
    defaultValue: '{{sensorType}} {{serialNumber}} is unreachable',
    sensorType: getActivitySensorTypeLabel(t, activity.sensor_serial_number),
    serialNumber: activity.sensor_serial_number
  });
}

export function getTransmitterUnreachableTitleText(t, activity) {
  return t('activity.activityFormat.titles.transmitterUnreachableTitle', {
    defaultValue: '{{serialNumber}} is unreachable',
    serialNumber: activity.sensor_serial_number
  });
}

export function getActivityObservationText(t, activity) {
  if (!activity) return '';

  const { event_type: eventType } = activity;

  if (eventType === 'mote_unreachable') {
    const unreachableText = getMoteUnreachableTitleText(t, activity);
    return activity.machine_name
      ? `${activity.machine_name} ${unreachableText}`
      : unreachableText;
  }

  if (eventType === 'tx_unreachable') {
    const unreachableText = getTransmitterUnreachableTitleText(t, activity);
    return activity.sensor_serial_number
      ? `${activity.sensor_serial_number} ${unreachableText}`
      : unreachableText;
  }

  return activity.description || '';
}

export function getEventDefinitionLabel(t, eventName, fallbackText) {
  return t(`settings.eventDefinitions.parameters.${eventName}`, {
    defaultValue: fallbackText || eventName.replace(/_/g, ' ')
  });
}
